<template>
    <facility-and-project-main-container>
        <template #title>
            Org. unit admin
        </template>
        <template #controls>
            <create-new-button
                button-text="Create new org.unit"
                library-name="OrganizationalUnit"
                @onClick="newOrgUnit" />
        </template>
        <template #new>
            <router-view
                :code-id="codeId"
                :title="!codeId ? 'Create new org.unit' : 'Edit org.unit'"
                :code-set-name="codeSetName"
                library="OrganizationalUnit"
                @onRefresh="refreshOrgUnits"
                @onCancel="cancelNew" />
        </template>
        <template #orgunits>
            <b-table
                :loading="loading"
                :data="orgUnitList"
                default-sort="name"
                :striped="true"
                :narrowed="true"
                :hoverable="true"
                class="site-sticky-header">
                <b-table-column
                    v-slot="props"
                    field="name"
                    label="Name"
                    sortable>
                    {{ props.row.Name }}
                </b-table-column>
                <b-table-column
                    v-slot="props"
                    field="description"
                    label="Description"
                    sortable>
                    {{ props.row.Description }}
                </b-table-column>
                <b-table-column
                    v-slot="props"
                    field="isValid"
                    label="Is valid"
                    centered
                    sortable>
                    <bool-element
                        :value="props.row.IsValid" />
                </b-table-column>
                <b-table-column
                    v-slot="props"
                    v-require-can-edit-code="{ libraryName: 'OrganizationalUnit' }"
                    field="id"
                    style="justify-content:flex-end"
                    label="Edit"
                    numeric>
                    <a
                        v-scroll-to="'#editor'"
                        class="button"
                        @click="edit(props.row.Id)">
                        <b-icon
                            icon="pencil"
                            size="is-small" />
                    </a>
                </b-table-column>
            </b-table>
        </template>
    </facility-and-project-main-container>
</template>

<script>
    import _ from 'lodash';
    import BoolElement from '@/shared/components/BoolElement.vue';
    import { requireCanEditCode } from '@/shared/directives/requirePermission';
    import { genericViewQueryAsText, getCodeSets } from '@/shared/helpers/api.ts';
    import { encodeIdBase64 } from '@/shared/helpers/utils';
    import ViewBaseFacilityAndProject from '@/apps/facilityAndProject/ViewBaseFacilityAndProject.vue';
    import CreateNewButton from '@/apps/facilityAndProject/CreateNewButton.vue';

    export default {
        directives: {
            'require-can-edit-code': requireCanEditCode
        },
        components: {
            CreateNewButton,
            FacilityAndProjectMainContainer: ViewBaseFacilityAndProject,
            BoolElement
        },
        data() {
            return {
                loading: true,
                codeId: null,
                orgUnitCodeEditKey: 1,
                showNewDialog: false,
                orgUnitList: [],
                orgUnitQuery: null,
                codeSetName: null
            };
        },
        watch: {
            orgUnitQuery(value) {
                this.orgUnitList = value;
                this.filterValid();
            }
        },
        async mounted() {
            await Promise.all([
                this.fetchOrgUnitList(),
                this.fetchCodeSetName()
            ]);
            this.loading = false;
        },
        methods: {
            async fetchOrgUnitList() {
                const list = (await genericViewQueryAsText(
                    this,
                    `FROM OrganizationalUnit
                    SELECT Id, Name, Description, IsValid`
                )).data;
                this.orgUnitQuery = _.sortBy(list, x => x.Name);
            },
            async fetchCodeSetName() {
                const codeSets = await getCodeSets(this, 'OrganizationalUnit');
                this.codeSetName = codeSets[0].name;
            },
            filterValid() {
                this.orgUnitList = this.orgUnitList.filter(x => x.isValid !== false);
            },
            newOrgUnit() {
                this.codeId = null;
                this.$router.push({ name: 'CreateNewOrgUnit' });
            },
            cancelNew() {
                this.$router.push({ name: 'OrgUnitList' });
            },
            async refreshOrgUnits() {
                this.$router.push({ name: 'OrgUnitList' });
                await this.fetchOrgUnitList();
            },
            edit(id) {
                this.codeId = encodeIdBase64('Code', id);
                this.$router.push({ name: 'EditOrgUnit' });
            }
        }
    };
</script>
